import { Injectable } from '@angular/core';
import { Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { IResponseMetaResult, RequestService } from '@df/api/request/request.service';
import { BehaviorSubject } from 'rxjs';

export type RouterBusyChangeCallback = (event: Event) => void;

@Injectable({
    providedIn: 'root'
})
export abstract class RouterBusyStateService {
    /**
     * If busy state
     */
    readonly busy$ = new BehaviorSubject(false);

    private readonly routerBusy$ = new BehaviorSubject(false);
    private readonly redirectBusy$ = new BehaviorSubject(false);

    constructor(router: Router, requestService: RequestService) {
        const updateBusy = () => {
            const busy = this.routerBusy$.value || this.redirectBusy$.value;
            if (this.busy$.value !== busy) {
                this.busy$.next(busy);
            }
        };

        this.routerBusy$.subscribe(updateBusy);
        this.redirectBusy$.subscribe(updateBusy);

        router.events.subscribe((event: Event) => {
            switch (true) {
                case event instanceof NavigationStart:
                    this.routerBusy$.next(true);
                    break;
                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError:
                    this.routerBusy$.next(false);
                    break;
            }
        });

        requestService.subscribe<IResponseMetaResult>(response => {
            const result = response?.result;
            if (result && (result.post_redirect || result.external_redirect)) {
                this.redirectBusy$.next(true);
            }
        });
    }
}
